module.exports = __webpack_public_path__ + "static/media/GuidedBreathingActivity.ca6ad318.mp3";